import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, takeUntil } from 'rxjs/operators';
import { PersonSearchService } from '../_services/person-search.service';
import { GlobalService } from '../_services/global.service';
import { LocalStorageService } from '../_services/local-storage.service';
import { AggregationService } from '../_services/aggregation.service';
import { RequestServiceService } from '../hire-person-search/request-service.service';
declare const clevertap;
@Component({
    selector: 'app-save-search-modal',
    templateUrl: './save-search-modal.component.html',
    styleUrls: ['./save-search-modal.component.scss'],
    standalone: false
})
export class SaveSearchModalComponent implements OnInit, OnDestroy {

  constructor(private activeModal: NgbActiveModal, private personSearchService: PersonSearchService, private localstorageservice: LocalStorageService,
    private aggregationService: AggregationService, private requestService: RequestServiceService) { }

  private searchNameInput$ = new Subject<string>();
  private destroy$ = new Subject<void>();

  @Input() talentdiscoveryhistoryid: string | number = null;
  @Input() searchName: string = null;
  @Input() module: string;
  @Input() type: string;
  @Input() calledFrom: string;

  saveSearchForm: UntypedFormGroup = new UntypedFormGroup({
    searchname: new UntypedFormControl(null, Validators.compose([Validators.required, Validators.minLength(2), Validators.maxLength(150), Validators.pattern(/^\s*\S.*\S\s*$/)]))
  });

  ngOnInit() {
    this.searchNameInput$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap((searchname: string) => this.personSearchService.checkSearchNameDuplicacy(searchname, this.module)),
      takeUntil(this.destroy$)
    ).subscribe((res: any) => {
      this.applyDuplicacyResult(res);
    }, (err: any) => {
      console.log("checkSearchNameDuplicacy() error - ", err);
    });

    if (this.searchName && this.type != 'update') {
      this.saveSearchForm.patchValue({
        searchname: this.searchName.trim()
      }, { emitEvent: false });
      this.checkSearchNameDuplicacy();
    }

    if (this.type == 'update') {
      this.saveSearchForm.patchValue({
        searchname: this.searchName ? this.searchName.trim() : null
      }, { emitEvent: false });
      this.saveSearchForm.get('searchname').disable();
    }

  }

  closeModal(type: string, message?: any) {
    if (type == 'error') {
      this.activeModal.dismiss(message);
    } else {
      this.activeModal.close(type == 'skip' ? 'user-dismissed' : message ? message : null);
    }
  }

  validateAllFormFields(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof UntypedFormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof UntypedFormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  checkSearchNameDuplicacy() {
    this.validateAllFormFields(this.saveSearchForm);

    const searchname: string = this.saveSearchForm.getRawValue()?.searchname?.trim();
    if (!this.saveSearchForm.valid) return;
    if (this.searchName && (this.searchName === searchname)) return;

    if (!(searchname && searchname.length > 1)) return;

    this.searchNameInput$.next(searchname);
  }

  private applyDuplicacyResult(res: any) {
    if (res && res.status === 'success') {
      if (res.duplicate) {
        this.saveSearchForm.controls['searchname'].setErrors({ ...this.saveSearchForm.controls['searchname'], duplicate: true });
      } else {
        this.saveSearchForm.controls['searchname'].errors && delete this.saveSearchForm.controls['searchname'].errors['duplicate']
      }
    } else {
      this.saveSearchForm.controls['searchname'].errors && delete this.saveSearchForm.controls['searchname'].errors['duplicate']
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  saveSearch() {
    this.validateAllFormFields(this.saveSearchForm);

    if (this.type == 'update') {
      this.UpdateSaveHistory();
    } else {
      if (this.saveSearchForm.valid) {

        const formValues = this.saveSearchForm.getRawValue();
        if (GlobalService.hasHTMLTags(formValues?.searchname)) {
          this.saveSearchForm.get("searchname").setErrors({
            htmlPresent: true
          });
          return;
        }
        const payload = {
          talentdiscoveryname: formValues?.searchname?.trim(),
          talentdiscoveryhistoryid: this.talentdiscoveryhistoryid
        }

        this.personSearchService.saveSearch(payload).subscribe((res: any) => {
          if (res && res.status === 'success') {
            this.closeModal('success', 'Saved successfully');
            this.localstorageservice.setItem('saveSearchName', formValues?.searchname);
            /**
         * save search CT event
         */
            if (this.module == 'talentinsights') {
              const saveSearchParams = {
                "User ID": this.localstorageservice.getItem('userdata').userid,
                "Search Name": formValues?.searchname?.trim(),
                "Filters Applied": JSON.stringify(this.aggregationService.getRequestWithFilters())
              }
              clevertap.event.push('Save Talent Insights Search', saveSearchParams);
            } else {
              const saveSearchParams = {
                "User ID": this.localstorageservice.getItem('userdata').userid,
                "Search Name": formValues?.searchname?.trim(),
                "Filters Applied": JSON.stringify(this.aggregationService.getRequestWithFilters())
              }
              clevertap.event.push('Search Saved', saveSearchParams);
            }

          } else {
            this.closeModal('error');
          }
        }, (err: any) => {
          console.log("saveSearch() err - ", err);
          this.closeModal('error', err);
        })
      }
    }


  }

  UpdateSaveHistory() {
    if(this.calledFrom == 'listing') {
      const reqBody = this.requestService.getHireRequestWithFilters();
       delete reqBody['aggregatetype'];
      delete reqBody['aggregatescount'];
      delete reqBody['resultsize'];
      delete reqBody['startindex'];

    reqBody['talentdiscoveryhistoryid'] = this.talentdiscoveryhistoryid.toString();
    reqBody['module'] = this.module;
    this.personSearchService.setInsightsHistory(reqBody).subscribe((res) => {
      this.closeModal('success', 'Update successfully');

    });
    } else {
      const reqBody = this.aggregationService.getRequestWithFilters()
      delete reqBody['aggregatetype'];
      delete reqBody['aggregatescount'];
      delete reqBody['resultsize'];
      delete reqBody['startindex'];

    reqBody['talentdiscoveryhistoryid'] = this.talentdiscoveryhistoryid.toString();
    reqBody['module'] = this.module;
    this.personSearchService.setInsightsHistory(reqBody).subscribe((res) => {
      this.closeModal('success', 'Update successfully');

    });
  }
}
}
